import React from 'react';
import { ButtonGroup } from '@lendi-ui/button';
import Modal from '@lendi-ui/modal';
import { Body, Heading } from '@lendi-ui/typography';

import { useAnalytics } from '@funnels/providers';
import { TrackingProps } from '@funnels/types';
import { run } from '@funnels/utils';

import { UppercaseBody } from '../../_common/style';
import { Content } from '../style';

interface DeleteModalProps {
  title: string;
  body?: string;
  isVisible: boolean;
  onHide: () => void;
  trackingProps?: TrackingProps;
  onDelete: (e: React.SyntheticEvent<Element, Event>) => void;
}

function DeleteModal(props: DeleteModalProps) {
  const { tracking } = useAnalytics();
  const { onDelete, trackingProps = {}, onHide } = props;

  return (
    <Modal role="dialog" isVisible={props.isVisible} size="md" onHide={onHide} isHeaderFixed={true}>
      <Modal.Content>
        <Content>
          <Heading size="sm" mb="md" mt="xxl">
            Delete {props.title}
          </Heading>
          {props.body && <Body mt="xxs">{props.body}</Body>}
          <Body mt="xxs">This cannot be undone.</Body>
          <Body mt="xxs">Do you want to continue?</Body>
        </Content>
      </Modal.Content>
      <Modal.Footer>
        <ButtonGroup isFullWidth size="md">
          <ButtonGroup.Button
            variant="emphasis"
            onClick={run(onDelete, () => tracking?.button.emphasis({ text: 'YES, DELETE NOW', ...trackingProps }))}
          >
            <UppercaseBody>yes, delete now</UppercaseBody>
          </ButtonGroup.Button>
          <ButtonGroup.Button
            variant="secondary"
            onClick={run(onHide, () => tracking?.button.secondary({ text: 'CANCEL', ...trackingProps }))}
          >
            <UppercaseBody>cancel</UppercaseBody>
          </ButtonGroup.Button>
        </ButtonGroup>
      </Modal.Footer>
    </Modal>
  );
}

export default DeleteModal;
